/** The /video page's address and settings (pack `widgets/video.json`). */
export const VIDEO_PATH = '/video';

export interface VideoSettings {
  title: string;
  /** A file in the pack's media/ folder. */
  file: string;
  poster?: string | undefined;
}

export function isVideoPath(pathname: string): boolean {
  return pathname.replace(/\/+$/, '') === VIDEO_PATH;
}

/** A pack media file's address (served to signed-in people, with byte ranges for seeking). */
export function mediaUrl(file: string): string {
  return `/v1/pack/media/${encodeURIComponent(file)}`;
}

/** The settings if the file is usable, else null (the page then says there is no video). */
export function readSettings(raw: unknown): VideoSettings | null {
  if (!raw || typeof raw !== 'object') return null;
  const { title, file, poster } = raw as Record<string, unknown>;
  if (typeof title !== 'string' || !title.trim() || typeof file !== 'string' || !file) return null;
  return { title: title.trim(), file, poster: typeof poster === 'string' && poster ? poster : undefined };
}
